import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Check = ({ label, children, name, checked, errorMessage, onChange, e2e, maxLength }) => {
  const handleChange = (e) => {
    onChange(e.target.checked, name);
  };

  const checkboxClass = cx('checkbox', {
    error: errorMessage,
  });

  const completeLabel = label || children;
  let labelParts = [completeLabel];
  if (completeLabel.indexOf('\\n') !== -1) {
    labelParts = completeLabel.split('\\n');
  }

  return (
    <div className={checkboxClass}>
      <input
        id={`checkbox-${name}`}
        type="checkbox"
        name={name}
        defaultChecked={checked}
        onChange={handleChange}
        data-e2e={e2e}
        maxLength={maxLength || 255}
        className={['sr-only', cx('input')].join(' ')}
      />
      <label htmlFor={`checkbox-${name}`} className={cx(styles.label)}>
        {labelParts.map((labelPart, labelIndex) => (
          <Fragment key={`checkbox-${name}-${labelPart}-${labelIndex}`}>
            {labelPart}
            {labelIndex !== labelParts.length - 1 ? <br /> : ''}
          </Fragment>
        ))}
      </label>
    </div>
  );
};

Check.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  name: PropTypes.string,
  checked: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  e2e: PropTypes.string,
  maxLength: PropTypes.string,
};

export default Check;
